import { useState, useEffect } from 'react'
import { stockPriceService, StockQuote } from '../services/stockPriceService'

export function useLiveStockPrices(symbols: string[], refreshInterval = 60000) {
  const [quotes, setQuotes] = useState<Map<string, StockQuote>>(new Map())
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!symbols || symbols.length === 0) return

    const fetchQuotes = async () => {
      setLoading(true)
      setError(null)
      
      try {
        const newQuotes = await stockPriceService.getQuotes(symbols)
        setQuotes(newQuotes)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch stock prices')
        console.error('Error fetching live prices:', err)
      } finally {
        setLoading(false)
      }
    }

    // Initial fetch
    fetchQuotes()

    // Set up interval for periodic updates
    const interval = setInterval(fetchQuotes, refreshInterval)

    // Cleanup
    return () => clearInterval(interval)
  }, [symbols, refreshInterval])

  return { quotes, loading, error }
}